import Program from 'wwg-utilities/dist/collections/program';

const getProgramSlug = (program: Program) => {
  return `/${program.slugifiedInstitutionName}/${
    program.slugifiedProgramName?.length
      ? program.slugifiedProgramName[0].name
      : ''
  }`;
};

export default getProgramSlug;
